
import axios from 'axios';
import styled from 'styled-components';
import { PointsContext, PointsProvider } from './pointContext';
import { animated, useSpring } from "react-spring";

import { Line } from 'react-chartjs-2';
import { Chart as ChartJS } from "chart.js/auto";
import { useState,useEffect, createContext, useContext, useMemo, useCallback ,useRef, useLayoutEffect } from 'react';
import PlayerForm from "./PlayerForm"
import SportNavBar from './sportNav';
import { PriceContext } from '../context';


import DemoSportNavBar from './DemoSportNav';
import CreditCounter from './CreditCounter';

import useSliderStore from '../config/useStore'

const PageContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100dvh;
  flex-direction: column;
  background-color: #131516; /* bg-[#131516] */
  justify-content: space-between;
  overflow-x: hidden;
  font-family: "Space Grotesk", "Noto Sans", sans-serif;
  color: #fff; /* Default text color as most elements are white */
`;

  const sportContainer = styled.div`
width:100%;
height:100%;
display:flex;
flex-direction:column;
background-color:green;
`;

const RowTwo = styled.div`
  height:60%;
  width:100vw%;
      flex-direction: row;
    justify-content: center;
    align-items: center;
`;
let yourPredictionVariable = 'b44'

const Data_wrap = styled.div`
width:100%;
display:grid;
  grid-area:data !important;
  grid-template-rows: repeat(3, 1fr); /* This creates three equal columns */
  gap: 10px; /* Optional: Adds space between the sections */
`;

const GridContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-left:15px;
  padding-right:15px;
  background-color: #1E2224; /* Darker background for individual chart containers */
  border-radius: 8px; /* Slightly rounded corners */
  overflow: hidden; /* Ensures content stays within rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */
`;
const ShiftContainer = styled.div`
  position:relative;
  width:100%;
  margin: 0 auto ;
  display:flex;
  flex-direction:column;
`;

const grid_wrap = styled.div`
  width: 100%;
  display: grid;
  grid-area: data !important;
  grid-template-columns: 30% 50% 20%; /* Defines the width of the three columns */
  gap: 10px; /* Optional: Adds space between the sections */
`;

const TopSection = styled.div`
background-color: #2C3135;  display: flex;
  justify-content: flex-end; 
  align-items: center; 
  padding: 10px; 
  padding-right: 20px; 
  height: 60px;
  height:30%;
  border-bottom: 1px solid #bbdefb; 
  border-bottom: 1px solid #41484E; /* Darker, subtle border */
  `;

  const StyledButton = styled(animated.button)`
  padding: 8px 15px;
  background-color: #4285f4; /* Google blue */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s ease; /* Smooth hover effect */

  &:hover {
    background-color: #3367d6;
  }
`;
const Container = styled.div`
display:flex;
flex-wrap:wrap;
align-content: flex-start;
justify-content:center;
flex-direction:row;
height:100%;
width:100%;

`;

const PContainer = styled(animated.div)`
  position:absolute;
  display:flex;
  width:100%;
  justify-content:center;
  z-indexx:702;
`;
const GraphWrapper = styled.div`
  width: 80%;
  height: 100dsvh;
  `

const StyledBackButton = styled.button`
  padding: 12px;
  border-radius: 50%;
  background-color: #3490dc;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #2779bd;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 4px rgba(100, 149, 237, 0.5);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #a0aec0;
  }

  svg {
    width: 24px;
    height: 24px;
    stroke: currentColor;
  }
`;

const StyledFlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px; /* Equivalent to space-x-4 */
  margin-bottom: 24px; /* Equivalent to mb-6 */
`;

const SportApp = () => {
  const parentRef = useRef(null);
  const [parentWidth, setParentWidth] = useState(0);
  const [browserWidth, setBrowserWidth] = useState(window.innerWidth);
  const [isPointPred , setPointPred] = useState(false)
  const [isAssistsPred , setAssistsPred] = useState(false)
  const [isReboundsPred , setReboundsPred] = useState(false)

  const [chartWidth, setChartWidth] = useState('10vw');
  const { email} = useContext(PriceContext);

  const isPointsOpen = useSliderStore((state) => state.openSliders.points);
    const isAssistsOpen = useSliderStore((state) => state.openSliders.assists);
  const isReboundsOpen = useSliderStore((state) => state.openSliders.rebounds);

  const toggle = useSliderStore((state) => state.toggle);

   useLayoutEffect(() => {
    if (parentRef.current) {
      setParentWidth(parentRef.current.offsetWidth);
    }
  }, []);

  const translateX = parentWidth * 0.5; // 50% of parent's width
  console.log('this is the width', translateX)

  const updateBrowserWidth = () => {
    const newWidth = window.innerWidth;
    setBrowserWidth(newWidth);

    if (newWidth < 500) {
      setChartWidth('100px');
    } else {
      setChartWidth('44vw');
    }
  };
useEffect(() => {
  window.addEventListener('resize', updateBrowserWidth);
  return () => {
      window.removeEventListener('resize', updateBrowserWidth);
  };
}, [chartWidth]);
  const { oldPlayer,setOld,user, points, setPoints, dates, setDates , assists, setAssists, rebounds, setRebounds, teams, setTeams, team_name, setTeamNames, playerNames, setPlayerNames, oneName, setName, setPointsPred_l, PointsPred_l, assistsPred_l, setAssistsPred_l, reboundsPred_l, setReboundsPred_l} = useContext(PointsContext);
  const { reboundsEndIndex, setReboundsEndIndex, reboundsStartIndex, setReboundsStartIndex ,assistsEndIndex, setAssistsEndIndex,assistsStartIndex, setAssistsStartIndex, endIndex, setEndIndex,startIndex, setStartIndex} = useContext(PointsContext)

const shift =useSpring({
transform: isPointsOpen ? `translate3d(0,0,0)` : `translate3d(${translateX}px, 0,0)`,
opacity: isPointsOpen ? 1:0,
 config: { mass: 1, tension: 280, friction: 60 },
// marginLeft: browserWidth < 600 ? `0rem` : `11rem`,

// width: browserWidth < 600 ? `100%` : `60%`,

display: 'flex',



})

const shiftAssists =useSpring({
transform: isAssistsOpen ? `translate3d(0,0,0)` : `translate3d(${translateX}px, 0,0)`,
opacity: isAssistsOpen ? 1:0,
 config: { mass: 1, tension: 280, friction: 60 },


display: 'flex',



})
const shiftRebounds =useSpring({
transform: isReboundsOpen ? `translate3d(0,0,0)` : `translate3d(${translateX}px, 0,0)`,
opacity: isReboundsOpen ? 1:0,
 config: { mass: 1, tension: 280, friction: 60 },


display: 'flex',



})
//  Chart Data  for Points Rebounds and assists 
  const allChartData = useMemo(() => {
    if (dates.length === 0 || points.length === 0) {
      return []; // Return empty array if data is not yet loaded
    }
    return dates.map((date, index) => ({
      date: date,
      value: points[index], // Using 'value' as the key for the chart line
    }));
  }, [dates, points]); 


    const allAssistsData = useMemo(() => {
    if (dates.length === 0 || assists.length === 0) {
      return []; // Return empty array if data is not yet loaded
    }
    return dates.map((date, index) => ({
      date: date,
      value: assists[index], // Using 'value' as the key for the chart line
    }));
  }, [dates, assists]);

    const allReboundsData = useMemo(() => {
    if (dates.length === 0 || rebounds.length === 0) {
      return []; // Return empty array if data is not yet loaded
    }
    return dates.map((date, index) => ({
      date: date,
      value: rebounds[index], // Using 'value' as the key for the chart line
    }));
  }, [dates, rebounds]);


    // --- Chart Window Configuration ---
  const pointsInView = 5; // Number of data points to display in the chart window
  const navigationStep = 1; // Number of points to move forward/backward with each click
  // State to manage the currently visible range of data points by their indices
  // Initialize startIndex and endIndex only after allChartData is available
 

  console.log(allChartData)
//- Assists window config
  const assistsInView = 5; // Number of data points to display in the chart window
  const assistsNavigationStep = 1; // Number of points to move forward/backward with each click

  // State to manage the currently visible range of data points by their indices
  // Initialize startIndex and endIndex only after allChartData is available




// Rebounds window config
  const reboundsInView = 5; // Number of data points to display in the chart window
  const reboundsNavigationStep = 1; // Number of points to move forward/backward with each click

  // State to manage the currently visible range of data points by their indices
  // Initialize startIndex and endIndex only after allChartData is available




  const chartDataForChartJS = useMemo(() => {
    // Ensure data is available before slicing
    if (allChartData.length === 0) {
      return { labels: [], datasets: [] };
    }
    console.log('chart data', allChartData)
    console.log('start and end inside')
    console.log(startIndex, endIndex)


    let baseStart = allChartData.length - pointsInView
    let baseEnd = allChartData.length 


    // Slice the original dates and points arrays based on current window indices
    const visibleData = allChartData.slice(startIndex, endIndex + 1);
    const visibleDates = visibleData.map(item => item.date);
    const visiblePoints = visibleData.map(item => item.value);

    return {
      labels: visibleDates,
      datasets: [
        {
          label: 'Points', // Label for the dataset
          data: visiblePoints, // The actual data points
          borderColor: 'rgb(79, 70, 229)', // Line color
          backgroundColor: 'rgba(79, 70, 229, 0.5)', // Area fill color (if applicable)
           responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false, // Prevents skipping ticks
        }
      }
    },
          fill: true, // Do not fill the area under the line by default
        },
      ],
    };
  }, [allChartData, startIndex, endIndex]);






const chartDataForAssists = useMemo(() => {
    // Ensure data is available before slicing
    if (allAssistsData.length === 0) {
      return { labels: [], datasets: [] };
    }
    // Slice the original dates and points arrays based on current window indices
    const visibleData = allAssistsData.slice(assistsStartIndex, assistsEndIndex+ 1);
    const visibleDates = visibleData.map(item => item.date);
    const visibleAssists = visibleData.map(item => item.value);

    return {
      labels: visibleDates,
      datasets: [
        {
          label: 'Assists', // Label for the dataset
          data: visibleAssists, // The actual data points
          backgroundColor: 'rgba(255, 206, 86, 0.6)', // Yellow
          borderColor: 'rgba(255, 206, 86, 1)',
            responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false, // Prevents skipping ticks
        }
      }
    },
          fill: true, // Do not fill the area under the line by default
        },
      ],
    };
  }, [allAssistsData, assistsStartIndex, assistsEndIndex]);



const chartDataForRebounds = useMemo(() => {
    // Ensure data is available before slicing
    if (allAssistsData.length === 0) {
      return { labels: [], datasets: [] };
    }
    // Slice the original dates and points arrays based on current window indices
    const visibleData = allReboundsData.slice(reboundsStartIndex, reboundsEndIndex+ 1);
    const visibleDates = visibleData.map(item => item.date);
    const visibleRebounds = visibleData.map(item => item.value);

    return {
      labels: visibleDates,
      datasets: [
        {
          label: 'Rebounds', // Label for the dataset
          data: visibleRebounds, // The actual data points
    backgroundColor: 'rgba(75, 192, 192, 0.6)', // Green
        borderColor: 'rgba(75, 192, 192, 1)',  // Area fill color (if applicable)
           responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false, // Prevents skipping ticks
        }
      }
    },
          fill: true, // Do not fill the area under the line by default
        },
      ],
    };
  }, [allReboundsData, reboundsStartIndex, reboundsEndIndex]);


  const point_data = {
    labels: dates,
    datasets: [
      {
        label: 'points',
        data: points,
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      },
    ],
teams:teams
  };

  const assist_data = {
    labels: dates,
    datasets: [
      {
        label: 'assists',
        data: assists,
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      },
    ],
  };

  const rebound_data = {
    labels: dates,
    datasets: [
      {
        label: 'rebounds',
        data: rebounds,
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      },
    ],
  };

  const roptions = {
    aspectRatio: 0.5
    // tooltips: {
    //   enabled: true,
    //   mode: 'index',
    //   intersect: false,
    //   callbacks: {
    //     label: function(tooltipItem, data) {
    //       const dataset = data.datasets[tooltipItem.datasetIndex];
    //       const value = dataset.data[tooltipItem.index];
    //       const date = data.labels[tooltipItem.index];
    //       const team = teams[tooltipItem.index]; // Assuming you have a `teams` variable
    //       return `Team: ${team}, Date: ${date}, Rebounds: ${value}`;
    //     },
    //   },
    // },
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false, // Prevents skipping ticks
        }
      }
    }
  };


  // Callback function to move the chart window backward
  const handleBack = useCallback(() => {
    setStartIndex(prev => Math.max(0, prev - navigationStep));
setEndIndex(prev => {
  console.log('this is prv', prev)
    const nextEnd = prev - navigationStep;
    // We must ensure the window stays the same size
    // So the end can't be smaller than (pointsInView - 1)
    return Math.max(pointsInView - 1, nextEnd);
  });  }, [navigationStep, pointsInView]);

  // Callback function to move the chart window forward
  const handleForward = useCallback(() => {
    setStartIndex(prev => Math.min(allChartData.length - pointsInView, prev + navigationStep));
    setEndIndex(prev => Math.min(allChartData.length - 1, prev + navigationStep));
  }, [navigationStep, pointsInView, allChartData.length]);

  // --- Button Disable Logic ---

  // Determine if the 'Back' button should be disabled
  // It's disabled if the current start index is 0
  const isBackButtonDisabled = useMemo(() => {
    return startIndex === 0;
  }, [startIndex]);

  // Determine if the 'Forward' button should be disabled
  // It's disabled if the current end index is at or beyond the last data point
  const isForwardButtonDisabled = useMemo(() => {
    return endIndex >= allChartData.length - 1;
  }, [endIndex, allChartData.length]);

// assists configuration

  const handleAssistsBack = useCallback(() => {
    setAssistsStartIndex(prev => Math.max(0, prev - assistsNavigationStep));
    setAssistsEndIndex(prev => {
      let nextEnd = prev - assistsNavigationStep
      return Math.max(assistsInView - 1, nextEnd)});
  }, [assistsNavigationStep, assistsInView]);

  // Callback function to move the chart window forward for assists
  const handleAssistsForward = useCallback(() => {
    setAssistsStartIndex(prev => Math.min(allChartData.length - assistsInView, prev + assistsNavigationStep));
    setAssistsEndIndex(prev => Math.min(allAssistsData.length - 1, prev + assistsNavigationStep));
  }, [assistsNavigationStep, assistsInView, allAssistsData.length]);

  // --- Button Disable Logic for Assists ---

  // Determine if the 'Back' button for assists should be disabled
  const isAssistsBackButtonDisabled = useMemo(() => {
    return assistsStartIndex === 0;
  }, [assistsStartIndex]);

  // Determine if the 'Forward' button for assists should be disabled
  const isAssistsForwardButtonDisabled = useMemo(() => {
    return assistsEndIndex >= allAssistsData.length - 1;
  }, [assistsEndIndex, allAssistsData.length]);


// Callback function to move the chart window backward for rebounds
  const handleReboundsBack = useCallback(() => {
    setReboundsStartIndex(prev => Math.max(0, prev - reboundsNavigationStep));
    setReboundsEndIndex(prev => Math.max(reboundsInView - 1, prev - reboundsNavigationStep));
  }, [reboundsNavigationStep, reboundsInView]);

  // Callback function to move the chart window forward for rebounds
  const handleReboundsForward = useCallback(() => {
    setReboundsStartIndex(prev => Math.min(allChartData.length - reboundsInView, prev + reboundsNavigationStep));
    setReboundsEndIndex(prev => Math.min(allChartData.length - 1, prev + reboundsNavigationStep));
  }, [reboundsNavigationStep, reboundsInView, allChartData.length]);

  // --- Button Disable Logic for Rebounds ---

  // Determine if the 'Back' button for rebounds should be disabled
  const isReboundsBackButtonDisabled = useMemo(() => {
    return reboundsStartIndex === 0;
  }, [reboundsStartIndex]);

  // Determine if the 'Forward' button for rebounds should be disabled
  const isReboundsForwardButtonDisabled = useMemo(() => {
    return reboundsEndIndex >= allChartData.length - 1;
  }, [reboundsEndIndex, allChartData.length]);

  const spendCredit = () => {
      try {
        axios({
          method: 'post',
          url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/credits`,
         
          withCredentials: false,
          data: {
            email:email,
            path:'user-spend-credit'
          },
        }).then(function (response) {
          
        })
        .catch(function (error) {
        });
  
  
  
      } catch (error) {
          console.error('Error:', error);
      }
  }

  return (
    
    <PageContainer>
      <SportNavBar itemss={playerNames} setPlayerNames={setPlayerNames} setTeamNames={setTeamNames} />


      {/* <CreditCounter/> */}

   
      <PlayerForm setOld={setOld} oldPlayer={oldPlayer} oneName={oneName} setName={setName} setDates={setDates} setPoints={setPoints} points={points} setRebounds={setRebounds} setAssists={setAssists} team={teams} setTeams={setTeams} setPointsPred_l={setPointsPred_l} setAssistsPred_l={setAssistsPred_l} setReboundsPred_l={setReboundsPred_l}/>

   

     <Data_wrap>
     
     <GridContainer ref={parentRef} >
       <grid_wrap>
      <StyledFlexContainer>
              <StyledBackButton onClick={handleBack}>  
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
              </StyledBackButton>

              <StyledBackButton onClick={handleForward}>
                            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              </StyledBackButton>
</StyledFlexContainer>
                          <Line data={chartDataForChartJS}  />

 <ShiftContainer>
          <PContainer style={shift}>
            {PointsPred_l}
          </PContainer>
        <TopSection>
        <StyledButton onClick={() => {
          toggle('points')
          spendCredit()
          }} >
              Points Pred
        </StyledButton>
      </TopSection>
       </ShiftContainer>
       </grid_wrap>
      </GridContainer>



  



      <GridContainer>
         <grid_wrap>
      <StyledFlexContainer>
              <StyledBackButton onClick={handleAssistsBack}>  
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
              </StyledBackButton>

              <StyledBackButton onClick={handleAssistsForward}>
                            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              </StyledBackButton>
</StyledFlexContainer>
                          <Line data={chartDataForAssists}  />
        <ShiftContainer  >
          <PContainer style={shiftAssists}>
{assistsPred_l}
          </PContainer>
        <TopSection>
        <StyledButton onClick={() => {
 toggle('assists')
           spendCredit()

          }} >
              Assists Pred
        </StyledButton>
      </TopSection>
        </ShiftContainer>

</grid_wrap>
      </GridContainer>

      <GridContainer>
         <grid_wrap>
      <StyledFlexContainer>
              <StyledBackButton onClick={handleReboundsBack}>  
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
              </StyledBackButton>

              <StyledBackButton onClick={handleReboundsForward}>
                            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              </StyledBackButton>
</StyledFlexContainer>
                          <Line data={chartDataForRebounds}  />
        <ShiftContainer  >
          <PContainer style={shiftRebounds}>
           {reboundsPred_l}
          </PContainer>
        <TopSection>
        <StyledButton onClick={() => { toggle('rebounds')
          spendCredit()
        }} >
              Rebounds Pred
        </StyledButton>
      </TopSection>
        </ShiftContainer>

</grid_wrap>
      </GridContainer>


    


     </Data_wrap>

   

 

    {/* <sportContainer>    
       <SportNavBar itemss={playerNames} setPlayerNames={setPlayerNames} setTeamNames={setTeamNames} />
       <CreditCounter/>

</sportContainer> */}


</PageContainer>

        );
};

export default SportApp;
